//Libs
import update from 'immutability-helper';
import { handleActions } from 'redux-actions';

//Redux store
import {
  LOAD_STAFF_DETAIL,
  LOAD_STAFF_DETAIL_SUCCESS,
  LOAD_STAFF_DETAIL_ERROR,
} from '../type';

export const initialState = {
  loadingStatus: {
    staffDetailLoading: false,
  },
  error: '',
  staffDetail: {},
};

const staffReducer = handleActions(
  new Map([
    [
      LOAD_STAFF_DETAIL,
      state => {
        return update(state, {
          loadingStatus: {
            staffDetailLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_STAFF_DETAIL_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            staffDetailLoading: { $set: false },
          },
          staffDetail: {
            $set: action.payload,
          },
        });
      },
    ],
    [
      LOAD_STAFF_DETAIL_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            staffDetailLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
  ]),
  initialState,
);
export default staffReducer;
